import { array, number, object } from '@gogame/schemas';

import { TAGS } from './constants';

export const validationSchema = object({
  [TAGS]: array(number()),
});
